var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0L60 0 60 60 0 60 0 60 0 0ZM29 50L29 47 14 47 14 43 29 43 29 39 14 39 14 36 29 36 29 32 11 32 11 50 11 50 29 50ZM50 50L50 47 36 47 36 36 50 36 50 32 32 32 32 50 32 50 50 50ZM29 29L29 25 14 25 14 14 29 14 29 11 11 11 11 29 11 29 29 29ZM47 21L47 25 32 25 32 29 50 29 50 18 36 18 36 14 50 14 50 11 32 11 32 21 32 21 47 21Z"}));
}

Logo.defaultProps = {"preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 60 60"};

module.exports = Logo;

Logo.default = Logo;
